import { useState, useEffect } from 'react';

import automatizacioncontrol from '../assets/automatizacioncontrol.jpg';
import controleselectricos from '../assets/controleselectricos.jpg';
import materialeselectricos from '../assets/materialeselectricos.jpg';
import neumatica from '../assets/neumatica.jpg';
import perfilesposter from '../assets/perfilesposter.png';
import teflonesposter from '../assets/teflonesposter.png';
import tornillosinoxidablesposter from '../assets/tornillosinoxidablesposter.png';
import herramientasposter from '../assets/herramientasposter.jpg';
import loclineposter from '../assets/LOCLINEposter.png';
import estanteriasposter from '../assets/estanteriaposter.png';

//categorias d eproductos NEUMATICA
import cilindrosneumaticos from '../assets/cilindrosneumaticos.jpg';
import valvulasdireccionales from '../assets/valvulasdireccionales.jpg';
import unidadesdemantenimiento from '../assets/unidadesdemantenimiento.jpg';
import Fitting from '../assets/Fitting.jpg';
import acoplesrapido from '../assets/acoplesrapido.jpg';
import valvulas from '../assets/valvulas.jpg';
import valvulas2vias from '../assets/valvulas2vias.jpg';
import mangueras from '../assets/mangueras.jpg';

//categorias d eproductos AUTOMATIZACION
import plcs from '../assets/plcs.jpg';
import contactores from '../assets/contactores.jpg';
import luces from '../assets/luces.jpg';
import pulsadores from '../assets/pulsadores.jpg';
import variadores from '../assets/variadores.jpg';
import sensores from '../assets/sensores.jpg';
import timers from '../assets/timers.jpg';
import breakers from '../assets/breakers.jpg';
import fusibles from '../assets/fusibles.jpg';
import controlestemperatura from '../assets/controlestemperatura.jpg';
import guardamotor from '../assets/guardamotor.jpg';


//categorias d eproductos TEFLONES
import teflonsinadhsivo from '../assets/teflonsinadhsivo.jpg';
import teflonconadhsivo from '../assets/teflonconadhsivo.jpg';
import terminalesAltatemperatura from '../assets/terminalesAltatemperatura.jpg';
import maquinasselladora from '../assets/maquinasselladora.jpg';
import katontape from '../assets/katontape.jpg';
import resistencia from '../assets/resistencia.jpg';
import tapeAltatemperatura from '../assets/tapeAltatemperatura.jpg';

//categorias d eproductos PERFILES
import perfiles from '../assets/perfiles.jpg';
import tuercasperfil from '../assets/tuercasperfil.jpg';
import tapasfinales from '../assets/tapasfinales.jpg';
import esquineros from '../assets/esquineros.jpg';
import placasunion from '../assets/placasunion.jpg';
import basespatas from '../assets/basespatas.jpg';
import tiradoresnylon from '../assets/tiradoresnylon.jpg';
import planchalexan from '../assets/planchalexan.jpg';
import planchasSeaboard from '../assets/planchasSeaboard.jpg';

//categorias d eproductos MATERIALES ELECTRICOS
import tornillosavellanados from '../assets/tornillosavellanados.jpg';
import tornillosallen from '../assets/tornillosallen.jpg';
import tornillosboton from '../assets/tornillosboton.jpg';
import tornilloshexagonales from '../assets/tornilloshexagonales.jpg';
import tornillosautorrocantes from '../assets/tornillosautorrocantes.jpg';
import remaches from '../assets/remaches.jpeg';

//categorias d eproductos MATERIALES ELECTRICOS
import tuberiaselectricas from '../assets/tuberiaselectricas.jpg';
import alambres from '../assets/alambres.jpg';
import abrazaderas from '../assets/abrazaderas.jpg';
import enchufesytoma from '../assets/enchufesytoma.jpg';
import interruptores from '../assets/interruptores.jpg';
import canaletas from '../assets/canaletas.jpg';
import cajaselectricas from '../assets/cajaselectricas.jpg';
import bornas from '../assets/bornas.jpg';

//categorias d eproductos HERRAMIENTAS
import ponchadoras from '../assets/ponchadoras.jpg';
import cizallas from '../assets/cizallas.jpg';
import sacabocado from '../assets/sacabocado.jpg';
import alicates from '../assets/alicates.jpg';
import destornilladores from '../assets/destornilladores.jpg';
import llaves from '../assets/llaves.jpg';
import portaherramientas from '../assets/portaherramientas.jpg';
import guantesoprotec from '../assets/guantesoprotec.jpg';
import seguetas from '../assets/seguetas.jpg';
import martillos from '../assets/martillos.jpg';

//categorias d eproductos loc-line
import mangueraslocline from '../assets/mangueraslocline.jpg';
import boquillaslocline from '../assets/boquillaslocline.jpeg';
import conectoreslocline from '../assets/conectoreslocline.jpeg';
import valvulaslocline from '../assets/valvulaslocline.jpeg';

//categorias d eproductos estanterias y rampas
import estanterialiviana from '../assets/estanteriaslivianas.jpeg';
import estanteriapesada from '../assets/estanteriapesada.jpg';
import racksindustriales from '../assets/racksindustriales.jpg';
import rampasmoviles from '../assets/rampasmoviles.jpeg';
import rampasfijas from '../assets/rampasfijas.jpeg';

const DepartmentPage = ({ departmentName, setCurrentPage }) => {
  const departmentData = {
    Neumática: {
      title: "Neumática Industrial",
      description: "Explora nuestra amplia gama de componentes y sistemas neumáticos de alta eficiencia, diseñados para optimizar el control de fluidos en tus procesos industriales. Ofrecemos soluciones robustas y duraderas para diversas aplicaciones.",
      mainImage: neumatica, // Imagen principal del departamento
      products: [
        { name: "Cilindros Neumáticos", image: cilindrosneumaticos},
        { name: "Válvulas Direccionales", image: valvulasdireccionales},
        { name: "Válvulas", image: valvulas},
        { name: "Válvulas 2 vias", image: valvulas2vias},
        { name: "Unidades de Mantenimiento", image: unidadesdemantenimiento},
        { name: "Mangueras", image: mangueras},
        { name: "Fittings", image: Fitting},
        { name: "Acoples rapidos", image: acoplesrapido},
      ]
    },
    "Automatización y Controles": {
      title: "Automatización y Controles",
      description: "Ofrecemos soluciones integrales en automatización industrial, desde PLCs y sensores hasta sistemas avanzados de control de procesos. Impulsa la eficiencia y precisión de tu producción con nuestra tecnología de vanguardia.",
      mainImage: automatizacioncontrol, // Imagen principal del departamento
      products: [
        { name: "PLCs y Controladores", image: plcs },
        { name: "Sensores Industriales", image: sensores},
        { name: "Contactores", image: contactores },
        { name: "Variadores de Frecuencia", image: variadores },
        { name: "Guardamotors", image: guardamotor },
        { name: "Luz pilotos", image: luces },
        { name: "Pulsadores", image: pulsadores },
        { name: "Timers", image: timers },
        { name: "Breakers", image: breakers },
        { name: "Fusibles", image: fusibles },
        { name: "Controles de temperatura", image: controlestemperatura },
      ]
    },
    Teflones: {
      title: "Teflones",
      description: "Especialistas en la venta y fabricación de piezas en teflón (PTFE) y otros polímeros de alto rendimiento. Ideales para aplicaciones industriales que requieren resistencia química, baja fricción y altas temperaturas.",
      mainImage: teflonesposter, // Imagen principal del departamento
      products: [
        { name: "Teflon sin Adhesivo", image: teflonsinadhsivo },
        { name: "Teflon con Adhesivo", image: teflonconadhsivo},
        { name: "Terminales Alta temperatura", image: terminalesAltatemperatura },
        { name: "Máquinas selladoras", image: maquinasselladora },
        { name: "Kapton Tape", image: katontape },
        { name: "Resistencias", image: resistencia },
        { name: "Tape de Alta Temperaturas", image: tapeAltatemperatura},
      ]
    },
    "Perfiles de Aluminio": {
      title: "Perfiles de Aluminio Modular",
      description: "Sistemas modulares de perfiles de aluminio para la construcción de estructuras industriales, estaciones de trabajo, transportadores, cerramientos de seguridad y sistemas de montaje personalizados. Ligeros, resistentes y versátiles.",
      mainImage: perfilesposter, // Imagen principal del departamento
      products: [
        { name: "Perfiles Estructurales", image: perfiles },
        { name: "Tapas finales", image:tapasfinales},
        { name: "Tuercas", image: tuercasperfil },
        { name: "Planchas lexan", image: planchalexan},
        { name: "Planchas Seaboard", image: planchasSeaboard},
        { name: "Soportes y Bases", image: basespatas},
        { name: "Tiradores de Nylon", image: tiradoresnylon},
        { name: "Esquineros", image: esquineros},
        { name: "Placas de union", image: placasunion},
      ]
    },
    "Tornillos Inoxidables": {
      title: "Tornillería de Acero Inoxidable",
      description: "Amplia gama de tornillería en acero inoxidable de alta calidad (A2, A4) para diversas aplicaciones industriales. Garantizamos resistencia a la corrosión, durabilidad y cumplimiento de las normativas más exigentes.",
      mainImage: tornillosinoxidablesposter, // Imagen principal del departamento
      products: [
        { name: "Tornillos Hexagonales", image: tornilloshexagonales },
        { name: "Tornillos avellanados", image: tornillosavellanados },
        { name: "Tornillos allen", image: tornillosallen},
        { name: "Tornillos cabeza boton", image: tornillosboton},
        { name: "Tornillos Autorroscantes", image: tornillosautorrocantes },
        { name: "Remaches Inoxidables", image: remaches},
      ]
    },
    "Materiales Eléctricos": {
      title: "Materiales Eléctricos Industriales",
      description: "Distribución de materiales eléctricos esenciales para instalaciones industriales, incluyendo cables, contactores, interruptores, protecciones, canalizaciones y accesorios. Soluciones seguras y eficientes para tu infraestructura eléctrica.",
      mainImage: materialeselectricos, // Imagen principal del departamento
      products: [
        { name: "Cables Industriales", image: alambres},
        { name: "Tuberias eléctricas", image: tuberiaselectricas},
        { name: "Abrazaderas", image: abrazaderas},
        { name: "Enchufes y Toma corrientes", image: enchufesytoma},
        { name: "Interruptores Eléctricos", image: interruptores },
        { name: "Canalizaciones", image: canaletas},
        { name: "Cajas eléctricas", image: cajaselectricas},
        { name: "Bornes y Conectores", image: bornas },
      ]
    },
    "Herramientas": {
    title: "Herramientas Industriales",
    description: "Amplia gama de herramientas industriales para montaje, mantenimiento y reparaciones. Desde herramientas manuales hasta eléctricas, todo lo que necesitas para tus proyectos con eficiencia y precisión.",
    mainImage: herramientasposter, // Imagen principal del departamento
    products: [
      { name: "Ponchadoras", image: ponchadoras },
      { name: "Destornilladores", image: destornilladores },
      { name: "Alicates", image: alicates },
      { name: "Llaves", image: llaves },
      { name: "Martillos", image: martillos },
      { name: "Sacabocados", image: sacabocado },
      { name: "Cizallas", image: cizallas },
      { name: "Portaherramientas", image: portaherramientas },
      { name: "Guantes de protección", image: guantesoprotec },
      { name: "Seguetas", image: seguetas },
    ]
  },
    "Loc-Line": {
    title: "Loc-Line",
    description: "Sistemas modulares de mangueras y accesorios Loc-Line ideales para refrigeración, aspiración de humos y direccionamiento de fluidos en procesos industriales.",
    mainImage: loclineposter, // Imagen principal del departamento
    products: [
      { name: "Mangueras modulares", image: mangueraslocline },
      { name: "Boquillas", image: boquillaslocline },
      { name: "Conectores", image: conectoreslocline },
      { name: "Válvulas", image: valvulaslocline },
    ]
  },

  "Estanterías Metálicas y Rampas Industriales": {
    title: "Estanterías Metálicas y Rampas Industriales",
    description: "Soluciones resistentes y versátiles para almacenamiento y logística, incluyendo estanterías metálicas de alta capacidad y rampas industriales seguras para carga y descarga.",
    mainImage: estanteriasposter, // Imagen principal del departamento
    products: [
      { name: "Estanterías livianas", image: estanterialiviana },
      { name: "Estanterías pesadas", image: estanteriapesada },
      { name: "Racks industriales", image: racksindustriales },
      { name: "Rampas móviles", image: rampasmoviles },
      { name: "Rampas fijas", image: rampasfijas },
    ]
  }
  };

  const data = departmentData[departmentName];

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) {
          element.classList.add('opacity-100', 'translate-y-0', 'scale-100');
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (page) => {
  setCurrentPage(page);
  window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!data) {
    return (
      <div className="py-20 px-4 bg-gray-50 text-center">
        <h1 className="text-4xl font-bold text-red-600 mb-8">Departamento no encontrado</h1>
        <button 
          onClick={() => setCurrentPage('home')} 
          className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
        >
          Volver al Inicio
        </button>
      </div>
    );
  }

  return (
    <div className="py-20 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl font-bold text-center text-gray-900 mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700">
          {data.title}
        </h1>

        {/* Imagen principal del departamento */}
        <div className="mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-100">
          <img 
            src={data.mainImage} 
            alt={data.title} 
            className="w-full h-96 object-cover rounded-xl shadow-xl mx-auto"
          />
        </div>

        <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-200">
          {data.description}
        </p>

        <h2 className="text-4xl font-bold text-center text-gray-900 mb-12 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-300">
          Catálogo de <span className="text-red-600">Productos</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {data.products.map((product, index) => (
            <div 
              key={index} 
              className={`bg-white p-6 rounded-xl shadow-xl transform hover:scale-105 transition-all duration-500 delay-${index * 100} animate-on-scroll opacity-0 translate-y-10`}
            >
              <div className="h-48 overflow-hidden rounded-lg mb-6">
                <img 
                  src={product.image} 
                  alt={product.name} 
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 text-center">{product.name}</h3>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-800">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">¿Necesitas más información?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Puedes ponerte en contacto con uno de nuestros vendedores para recibir ayuda personalizada y conocer más detalles sobre nuestros productos.
          </p>
          <button 
            onClick={() => handleNavigation('contact')} 
            className="mt-10 bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
          >
            Contactar a un experto
          </button>
        </div>
      </div>
    </div>
  );
};
export default DepartmentPage;

// DONE